import React, { useState } from 'react';
import { ArrayStringStyle, CollapseListStyle } from './ArrayString.style';
import { Collapse } from 'antd';
import { useTranslation } from 'react-i18next';

const { Panel } = Collapse;

export interface ArrayStringTableCellTypes {
  type: 'stringArray';
  data: Array<string>;
}

interface Props {
  /** dane przychodzące */
  data: Array<string>;
}

/**
 * Komponent generowany dla typu tablica stringów
 *
 * @param data
 */
export default function ArrayString({ data }: Props): JSX.Element {
  const [panelOpened, setPanelOpened] = useState(false);
  const { t } = useTranslation();

  const preventClick = (e: any): void => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <React.Fragment>
      {data.length ? (
        <CollapseListStyle onClick={preventClick}>
          <Collapse bordered={false} onChange={(tab: string[] | string): void => setPanelOpened(!!tab.length)}>
            <Panel header={t(panelOpened ? 'COLLAPSE' : 'EXPAND')} key='1'>
              <ArrayStringStyle>
                {data.map((row: string, index: number) => (row.length > 0 ? <li key={index}>{row}</li> : null))}
              </ArrayStringStyle>
            </Panel>
          </Collapse>
        </CollapseListStyle>
      ) : (
        data
      )}
    </React.Fragment>
  );
}
